import React from 'react'

const CENTRAL_SALES_ID = ['AngHA', 'ChanJX', 'ColinP', 'FongMN', 'LaiCF', 'KhorTA']

export const PointsRemaining = ({ point: rowPoint, totalPoint, salesId = '' }) => {
  const point = totalPoint || rowPoint
  const isCentralSales = CENTRAL_SALES_ID.includes(salesId)
  const chinaThreshold = isCentralSales ? 8400 : 7000
  const seaThreshold = isCentralSales ? 5400 : 4500

  return (
    <>
      <span style={{ color: point - chinaThreshold < 0 ? 'red' : 'green' }}>
        China: {point - chinaThreshold}
      </span>
      <br />
      <span style={{ color: point - seaThreshold < 0 ? 'red' : 'green' }}>
        SEA: {point - seaThreshold}
      </span>
    </>
  )
}
